import Lookup from 'src/componentes/select2';

const CriteriosEfetividadeLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/CriteriosEfetividadeLookup"
    clearable={false}
    {...rest}
  />
);

export default CriteriosEfetividadeLookup;
